import React from "react";

// True on narrow (phone-ish) viewports — including phones held sideways,
// which are wide but far too short for full-size windows. The desktop
// metaphor scales down rather than being replaced: same chrome, compact
// arrangement.
const QUERY = "(max-width: 700px), (max-height: 500px)";

export default function useCompactMode() {
  const [compact, setCompact] = React.useState(
    () => typeof window !== "undefined" && window.matchMedia(QUERY).matches,
  );
  React.useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setCompact(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return compact;
}

// Current viewport size, updated on resize — used to scale fixed-size
// windows down to fit small screens.
export function useViewportSize() {
  const read = () =>
    typeof window !== "undefined"
      ? { width: window.innerWidth, height: window.innerHeight }
      : { width: 1600, height: 900 };
  const [size, setSize] = React.useState(read);
  React.useEffect(() => {
    const onResize = () => setSize(read());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return size;
}

export function useViewportWidth() {
  return useViewportSize().width;
}
